'use client';

import { c as _c } from "react/compiler-runtime";
import { DropdownMenu } from '@common/components';
import { Pagination } from '@common/components/molecule/Pagination';
import { Fragment } from 'react';
import { SearchCategoryAdSlot } from '@/app/_components/ads';
import type { PolicySortOption } from '../../_hooks/usePolicyFilter';
import { EMPTY_SEARCH_RESULT_MESSAGE, PAGE_SIZE } from '../../constants';
import type { PolicyData } from './SearchPolicyCard';
import { SearchPolicyCard } from './SearchPolicyCard';
import { SearchPolicyCardSkeletonList } from './SearchPolicyCardSkeleton';
const SORT_LABEL: Record<PolicySortOption, string> = {
  SCORE: '정확도순',
  LATEST: '최신순'
};
const SORT_OPTIONS = (Object.keys(SORT_LABEL) as PolicySortOption[]).map(value => ({
  value,
  label: SORT_LABEL[value]
}));
interface PolicyResultListProps {
  policies: PolicyData[];
  totalCount: number;
  sort: PolicySortOption;
  onSortChange: (sort: PolicySortOption) => void;
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  isLoading?: boolean;
  emptyMessage?: string;
}
export function PolicyResultList(t0) {
  const $ = _c(24);
  const {
    policies,
    totalCount,
    sort,
    onSortChange,
    page,
    totalPages,
    onPageChange,
    isLoading: t1,
    emptyMessage: t2
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const emptyMessage = t2 === undefined ? EMPTY_SEARCH_RESULT_MESSAGE : t2;
  let t3;
  if ($[0] !== isLoading || $[1] !== totalCount) {
    t3 = isLoading ? "\uAC80\uC0C9 \uACB0\uACFC" : `전체 ${totalCount.toLocaleString()}건`;
    $[0] = isLoading;
    $[1] = totalCount;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <p className="font-700 text-Gray-black typo-body4 mobile-tablet:font-500">{t3}</p>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onSortChange || $[6] !== sort) {
    t5 = <DropdownMenu type="text" align="end" options={SORT_OPTIONS} value={sort} onChange={onSortChange} contentClassName="min-w-150" />;
    $[5] = onSortChange;
    $[6] = sort;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className="flex items-center justify-between mobile-tablet:px-20">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== emptyMessage || $[12] !== isLoading || $[13] !== policies) {
    t7 = <div className="flex flex-1 flex-col">{isLoading ? <SearchPolicyCardSkeletonList count={PAGE_SIZE} /> : policies.length > 0 ? <div className="flex flex-col gap-12 pb-20 mobile-tablet:gap-0 mobile-tablet:pb-0">{policies.map((policy, idx) => <Fragment key={policy.id}><SearchCategoryAdSlot placement="search-policy" position={idx + 1} listLength={policies.length} /><SearchPolicyCard policy={policy} /></Fragment>)}</div> : <div className="flex-1 py-80 flex-center"><p className="text-Gray-550 typo-body4">{emptyMessage}</p></div>}</div>;
    $[11] = emptyMessage;
    $[12] = isLoading;
    $[13] = policies;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== onPageChange || $[16] !== page || $[17] !== totalCount || $[18] !== totalPages) {
    t8 = totalPages > 1 && <Pagination totalCount={totalCount} currentPage={page} size={PAGE_SIZE} onMovePage={onPageChange} perButtonCount={5} className="my-0 pb-40" />;
    $[15] = onPageChange;
    $[16] = page;
    $[17] = totalCount;
    $[18] = totalPages;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = <div className="flex min-w-0 flex-1 flex-col">{t6}{t7}{t8}</div>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}